import { RevealEffectDefinition } from 'types';

const zoomDefinition: RevealEffectDefinition = {
  name: 'zoom',
  start: {
    opacity: 0.5,
    transform: 'scale3d(0.9,0.9,0.9); translate3d(0, 25px, 0)'
  },
  animation: {
    zoom: {
      animation: '$zoomOpacity .3s ease-in-out, $zoomTransform .7s ease-in-out',
      animationFillMode: 'forwards'
    },
    '@keyframes zoomOpacity': {
      to: {
        opacity: 1
      }
    },
    '@keyframes zoomTransform': {
      to: {
        transform: 'scale3d(1, 1, 1); translate3d(0, 0px, 0);'
      }
    }
  },
  shouldReveal(element): boolean {
    const rect = element.getBoundingClientRect();
    return (
      (rect.top >= 0 && rect.top <= window.innerHeight) ||
      (rect.bottom >= 0 && rect.bottom <= window.innerHeight) ||
      (rect.top <= 0 && rect.bottom >= window.innerHeight)
    );
  },
  reveal(element, classes): void {
    element.classList.add(classes.zoom);
  }
};

export default zoomDefinition;
